/* Bioss pathway product cards
   For pathways with a curated SKU list, replaces the "Shop targets" search box with
   real product cards (target, name, SKU, applications, price, Add to Cart).
   Live data comes from /products/<handle>.js; a preview snapshot (window.BiossPathwayProductData)
   is used as a fallback so the standalone preview renders offline. */
(function () {
  var root = document.querySelector('[data-bioss-product-pathways]') || document.querySelector('[data-bioss-pathways-hub]');
  if (!root) { return; }
  var productMode = root.hasAttribute('data-bioss-product-pathways');
  var currentHandle = root.getAttribute('data-product-handle');
  var routeRoot = root.getAttribute('data-route-root') || '/';
  var pathwaySelect = root.querySelector('[data-product-pathway-select]');
  var productStatus = root.querySelector('[data-product-pathway-status]');

  // Curated product lists keyed by pathway slug. Order follows the pathway map.
  var MANIFEST = {
    autophagy: [
      { handle: 'bs-1992r', target: 'mTOR' },
      { handle: 'bs-8161r', target: 'GβL' },
      { handle: 'bs-3559r', target: 'Raptor' },
      { handle: 'bs-3602r', target: 'ULK1' },
      { handle: 'bs-3864r', target: 'Atg13' },
      { handle: 'bs-8165r', target: 'FIP200' },
      { handle: 'bs-1353r', target: 'Beclin1' },
      { handle: 'bs-7462r', target: 'Atg14' },
      { handle: 'bs-4159r', target: 'PI3K (Class III)' },
      { handle: 'bs-4012r', target: 'Atg12' },
      { handle: 'bs-5991r', target: 'Atg10' },
      { handle: 'bs-2432r', target: 'Atg7' },
      { handle: 'bs-4005r', target: 'Atg5' },
      { handle: 'bs-4007r', target: 'Atg16L' },
      { handle: 'bs-8878r', target: 'LC3' },
      { handle: 'bs-11731r', target: 'LC3A/B (LC3-II)' },
      { handle: 'bs-3873r', target: 'Atg4' },
      { handle: 'bs-4013r', target: 'Atg3' },
      { handle: 'bs-1970r', target: 'LAMP1' },
      { handle: 'bs-2379r', target: 'LAMP2' }
    ],
    alzheimers: [
      { handle: 'bs-0112r', target: 'APP', search: 'Amyloid Precursor Protein' },
      { handle: 'bs-4236r', target: 'ADAM17' },
      { handle: 'bs-0164r', target: 'BACE1' },
      { handle: 'bs-0024r', target: 'Presenilin 1', alts: 2 },
      { handle: 'bs-6058r', target: 'Nicastrin' },
      { handle: 'bs-6456r', target: 'PEN2' },
      { handle: 'bs-4259r', target: 'APH1A' },
      { handle: 'bs-0107r', target: 'beta Amyloid 1-42', search: 'beta Amyloid', alts: 4 },
      { handle: 'bs-12503r', target: 'APP-BP1' },
      { handle: 'bs-5038r', target: 'ApoE', alts: 2 },
      { handle: 'bs-2200r', target: 'LDL' },
      { handle: 'bs-0527r', target: 'Neprilysin (NEP)', search: 'Neprilysin' },
      { handle: 'bs-0018r', target: 'IDE' },
      { handle: 'bs-2677r', target: 'LRP1' },
      { handle: 'bs-0028r', target: 'GSK-3 beta', search: 'GSK3', alts: 2 },
      { handle: 'bs-0559r', target: 'CDK5' },
      { handle: 'bs-11611r', target: 'p35 / CDK5R1', search: 'p35' },
      { handle: 'bs-10106r', target: 'Tau', alts: 4 },
      { handle: 'bs-0968r', target: 'Alpha-Synuclein' },
      { handle: 'bs-2469r', target: 'PERK' },
      { handle: 'bs-8680r', target: 'IRE1 alpha', search: 'IRE1' },
      { handle: 'bs-1634r', target: 'ATF6' },
      { handle: 'bs-0013r', target: 'Cytochrome C' },
      { handle: 'bs-0058r', target: 'Apaf-1', alts: 1 },
      { handle: 'bs-0049r', target: 'Caspase-9', alts: 1 },
      { handle: 'bs-0084r', target: 'Caspase-6' },
      { handle: 'bs-1153r', target: 'Bid' },
      { handle: 'bs-0511r', target: 'FADD', alts: 3 },
      { handle: 'bs-1099r', target: 'Calpain-1' },
      { handle: 'bs-0078r', target: 'TNF alpha', search: 'TNF' },
      { handle: 'bs-0812r', target: 'IL-1 beta', search: 'IL-1', alts: 4 },
      { handle: 'bs-13282r', target: 'GAPDH' }
    ],
    apoptosis: [
      { handle: 'bs-0078r', target: 'TNF alpha', search: 'TNF' },
      { handle: 'bs-0215r', target: 'FAS / CD95', search: 'FAS' },
      { handle: 'bs-6319r', target: 'IL-1 beta', search: 'IL-1' },
      { handle: 'bs-0511r', target: 'FADD' },
      { handle: 'bs-1047r', target: 'MyD88' },
      { handle: 'bs-0052r', target: 'Caspase-8' },
      { handle: 'bs-0050r', target: 'Caspase-9' },
      { handle: 'bs-0081r', target: 'Caspase-3' },
      { handle: 'bs-0151r', target: 'Caspase-6' },
      { handle: 'bs-1105r', target: 'Caspase-12' },
      { handle: 'bs-0032r', target: 'Bcl-2' },
      { handle: 'bs-0127r', target: 'Bax' },
      { handle: 'bs-1304r', target: 'Bad' },
      { handle: 'bs-3012r', target: 'Bim', search: 'Bim' },
      { handle: 'bs-0013r', target: 'Cytochrome C' },
      { handle: 'bs-0128r', target: 'PI3K (PIK3R1)', search: 'PI3K' },
      { handle: 'bs-0115r', target: 'AKT' },
      { handle: 'bs-0520r', target: 'PKA' },
      { handle: 'bs-0033r', target: 'p53' },
      { handle: 'bs-4262r', target: 'cIAP1' }
    ],
    bcellreceptor: [
      { handle: 'bs-2906r', target: 'Lyn', alts: 1 },
      { handle: 'bs-0685r', target: 'Syk', alts: 2 },
      { handle: 'bs-0079r', target: 'CD19', alts: 2 },
      { handle: 'bs-1481r', target: 'CD22' },
      { handle: 'bs-2885r', target: 'Gab2', search: 'Gab' },
      { handle: 'bs-0128r', target: 'PI3K p85', search: 'PI3K p85', alts: 1 },
      { handle: 'bs-6417r', target: 'PI3K p110', search: 'PI3K p110', alts: 1 },
      { handle: 'bs-1180r', target: 'RhoA', alts: 1 },
      { handle: 'bs-1343r', target: 'Ezrin', alts: 1 },
      { handle: 'bs-2932r', target: 'Clathrin' },
      { handle: 'bs-4286r', target: 'Vav3', search: 'Vav' },
      { handle: 'bs-6154r', target: 'Rac1/Rac2', search: 'Rac', alts: 1 },
      { handle: 'bs-3357r', target: 'Pyk2' },
      { handle: 'bs-3054r', target: 'BLNK' },
      { handle: 'bs-1033r', target: 'Ras (KRAS)', search: 'Ras', alts: 1 },
      { handle: 'bs-1703r', target: 'c-Raf', alts: 2 },
      { handle: 'bs-3270r', target: 'MEK1/2', search: 'MEK1/2' },
      { handle: 'bs-0022r', target: 'ERK1/2', search: 'ERK1/2', alts: 2 },
      { handle: 'bs-1979r', target: 'MKK4/7 (MEK7)', search: 'MKK7', alts: 1 },
      { handle: 'bs-1689r', target: 'MKK3/4/6 (MEK3)', search: 'MEK3' },
      { handle: 'bs-0267r', target: 'PKC beta', search: 'PKC', alts: 2 },
      { handle: 'bs-0637r', target: 'p38 MAPK', search: 'p38' },
      { handle: 'bs-1640r', target: 'JNK1/2/3', search: 'JNK', alts: 1 },
      { handle: 'bs-3585r', target: 'TAK1', alts: 2 },
      { handle: 'bs-2733r', target: 'Bcl-10' },
      { handle: 'bs-0465r', target: 'NF-kB p65', search: 'NF-kB' },
      { handle: 'bs-0115r', target: 'AKT' },
      { handle: 'bs-1992r', target: 'mTOR', alts: 2 },
      { handle: 'bs-4114r', target: 'IKK epsilon', search: 'IKK', alts: 2 },
      { handle: 'bs-1656r', target: 'p70 S6 Kinase', search: 'p70 S6' },
      { handle: 'bs-2537r', target: 'FoxO1', search: 'FoxO', alts: 2 },
      { handle: 'bs-0035m', target: 'CREB', alts: 2 },
      { handle: 'bs-0670r', target: 'c-Jun', search: 'Jun' },
      { handle: 'bs-0518r', target: 'ATF-2', alts: 2 },
      { handle: 'bs-2734r', target: 'Bcl-6' },
      { handle: 'bs-1398r', target: 'Elk-1', alts: 1 },
      { handle: 'bs-1076r', target: 'Egr-1' },
      { handle: 'bs-5234r', target: 'Bcl-XL' }
    ],
    complementsystem: [
      { handle: 'bs-15086r', target: 'C1r' },
      { handle: 'bs-15088r', target: 'C1s' },
      { handle: 'bs-8613r', target: 'Complement C2', search: 'Complement C2' },
      { handle: 'bs-10428r', target: 'C2a' },
      { handle: 'bs-2934r', target: 'Complement C3', search: 'Complement C3', alts: 1 },
      { handle: 'bs-4871r', target: 'C3b', search: 'Complement C3b' },
      { handle: 'bs-15186r', target: 'Complement C4', search: 'Complement C4', alts: 2 },
      { handle: 'bs-10452r', target: 'C4b' },
      { handle: 'bs-15197r', target: 'Complement C5', search: 'Complement C5' },
      { handle: 'bs-0367g', target: 'C5a', search: 'Complement C5a', alts: 1 },
      { handle: 'bs-15307r', target: 'Complement C9', search: 'Complement C9' },
      { handle: 'bs-6949r', target: 'Factor B' },
      { handle: 'bs-13130r', target: 'Factor D' },
      { handle: 'bs-9525r', target: 'Factor H (CFH)', search: 'Factor H', alts: 1 },
      { handle: 'bs-10339r', target: 'Factor I', alts: 1 },
      { handle: 'bs-1552r', target: 'DAF / CD55', search: 'CD55' },
      { handle: 'bs-15184r', target: 'C4BP' },
      { handle: 'bs-1529r', target: 'CD46 / MCP', search: 'CD46', alts: 1 },
      { handle: 'bs-1638r', target: 'CD59' },
      { handle: 'bs-10144r', target: 'CR1 / CD35', search: 'CR1' },
      { handle: 'bs-3792r', target: 'CR2 / CD21', search: 'CR2' }
    ],
    igf1rsignaling: [
      { handle: 'bs-0014r', target: 'IGF1', alts: 1 },
      { handle: 'bs-0015r', target: 'IGF2' },
      { handle: 'bs-0227r', target: 'IGF1R', alts: 2 },
      { handle: 'bs-0172r', target: 'IRS1', alts: 2 },
      { handle: 'bs-0173r', target: 'IRS2' },
      { handle: 'bs-2067r', target: 'PI3K p110α', search: 'PIK3CA', alts: 1 },
      { handle: 'bs-0128r', target: 'PI3K p85', search: 'PI3K p85', alts: 1 },
      { handle: 'bs-3017r', target: 'PDK1', alts: 1 },
      { handle: 'bs-0267r', target: 'PKC beta', search: 'PKC', alts: 1 },
      { handle: 'bs-0384r', target: 'GLUT4' },
      { handle: 'bs-0115r', target: 'AKT', alts: 2 },
      { handle: 'bs-0028r', target: 'GSK-3 beta', search: 'GSK3', alts: 2 },
      { handle: 'bs-1992r', target: 'mTOR', alts: 2 },
      { handle: 'bs-1656r', target: 'p70 S6 Kinase', search: 'p70 S6' },
      { handle: 'bs-1304r', target: 'BAD', alts: 1 },
      { handle: 'bs-9654r', target: '14-3-3', alts: 2 },
      { handle: 'bs-0049r', target: 'Caspase-9', alts: 2 },
      { handle: 'bs-2537r', target: 'FoxO1', search: 'FoxO', alts: 2 },
      { handle: 'bs-4114r', target: 'IKK epsilon', search: 'IKK', alts: 2 },
      { handle: 'bs-0465r', target: 'NF-kB p65', search: 'NF-kB', alts: 1 },
      { handle: 'bs-0032r', target: 'Bcl-2', alts: 2 },
      { handle: 'bs-3572r', target: 'Shc / SHC1', search: 'Shc', alts: 2 },
      { handle: 'bs-1465r', target: 'GRB2' },
      { handle: 'bs-1033r', target: 'Ras (KRAS)', search: 'Ras', alts: 1 },
      { handle: 'bs-1703r', target: 'c-Raf', alts: 1 },
      { handle: 'bs-3270r', target: 'MEK1/2', search: 'MEK1/2' },
      { handle: 'bs-3016r', target: 'ERK1/2', search: 'ERK1/2' },
      { handle: 'bs-1398r', target: 'Elk-1', alts: 1 }
    ],
    mapksignaling: [
      { handle: 'bs-1071r', target: 'Ras (HRAS)', search: 'Ras' },
      { handle: 'bs-6154r', target: 'RAC1/2', search: 'RAC' },
      { handle: 'bs-2440r', target: 'IRAK4' },
      { handle: 'bs-1184r', target: 'TRAF6' },
      { handle: 'bsm-61166r', target: 'ASK1' },
      { handle: 'bs-3585r', target: 'TAK1' },
      { handle: 'bs-1041r', target: 'MEK1/2', search: 'MEK1/2' },
      { handle: 'bs-1689r', target: 'MEK3/6', search: 'MEK3' },
      { handle: 'bs-1020r', target: 'ERK1/2', search: 'ERK1/2' },
      { handle: 'bs-2592r', target: 'JNK1/2/3', search: 'JNK' },
      { handle: 'bs-0637r', target: 'p38 MAPK', search: 'p38' },
      { handle: 'bs-0730r', target: 'HSP27' },
      { handle: 'bs-0469r', target: 'c-FOS', search: 'c-fos' },
      { handle: 'bs-1141r', target: 'STAT3' },
      { handle: 'bs-1398r', target: 'ELK1' },
      { handle: 'bs-0670r', target: 'c-JUN', search: 'c-Jun' },
      { handle: 'bs-0035r', target: 'CREB' },
      { handle: 'bs-0518r', target: 'ATF2' },
      { handle: 'bs-4963r', target: 'c-Myc' }
    ],
    nfkb: [
      { handle: 'bs-1286r', target: 'CD40L', search: 'CD40L' },
      { handle: 'bs-0078r', target: 'TNF-alpha', search: 'TNF alpha' },
      { handle: 'bs-6319r', target: 'IL-1 beta', search: 'IL-1 beta' },
      { handle: 'bs-1202r', target: 'TRADD' },
      { handle: 'bs-1213r', target: 'TRAF2' },
      { handle: 'bs-1185r', target: 'TRAF3' },
      { handle: 'bs-0511r', target: 'FADD' },
      { handle: 'bs-1184r', target: 'TRAF6' },
      { handle: 'bs-1047r', target: 'MyD88' },
      { handle: 'bs-6464r', target: 'IRAK1' },
      { handle: 'bs-4262r', target: 'cIAP1' },
      { handle: 'bs-0074r', target: 'NIK', search: 'NIK' },
      { handle: 'bs-1433r', target: 'MEKK', search: 'MEK1' },
      { handle: 'bs-2907r', target: 'IKK alpha', search: 'IKK alpha' },
      { handle: 'bs-10123r', target: 'IKK alpha/beta', search: 'IKK beta' },
      { handle: 'bs-22575r', target: 'IKK gamma / NEMO', search: 'IKK gamma' },
      { handle: 'bs-10246r', target: 'IkB beta', search: 'IkB beta' },
      { handle: 'bs-0465r', target: 'p65 / RelA', search: 'NFKB p65' },
      { handle: 'bs-1194r', target: 'p50 / NFKB1', search: 'NFKB1' },
      { handle: 'bs-10037r', target: 'p52 / NFKB2', search: 'NFKB2' },
      { handle: 'bs-3562r', target: 'RelB' }
    ]
  };

  var cardsEl = root.querySelector('[data-bioss-pathway-product-cards]');
  var linksEl = root.querySelector('[data-bioss-pathway-links]');
  var targetGroup = root.querySelector('[data-bioss-pathway-target-group]');
  var collectionGroup = root.querySelector('[data-bioss-pathway-collection-group]');
  var titleEl = root.querySelector('[data-bioss-pathway-title]');
  if (!cardsEl) { return; }

  var isPreview = !!window.BiossPathwayPreview;
  var snapshot = window.BiossPathwayProductData || {};
  var cache = {};
  var renderedSlug = null;
  var cardObserver = null;

  function slug(v) {
    return String(v || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  // Collapse to alphanumerics so "Alzheimer's" (-> alzheimer-s) matches the "alzheimers" key.
  function pathKey(v) { return slug(v).replace(/-/g, ''); }
  function activeSlug() {
    if (productMode) return pathwaySelect.value;
    var t = titleEl ? pathKey(titleEl.textContent) : '';
    return t || pathKey((window.location.hash || '').replace(/^#/, ''));
  }
  function searchUrl(q) {
    return '/search?type=product&view=spring&q=' + encodeURIComponent(q);
  }
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    if (productMode) return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD' }).format(n);
    return '$' + n.toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function appsFromTags(tags) {
    if (!tags) { return []; }
    var seen = {}, out = [];
    tags.forEach(function (t) {
      if (t.indexOf('applications_') === 0) {
        var a = t.slice(13);
        if (a && !seen[a]) { seen[a] = 1; out.push(a); }
      }
    });
    return out;
  }
  function pickVariant(p) {
    var vs = p.variants || [];
    return vs.filter(function (v) { return v.available && /100/.test(String(v.option1 || v.title || '')); })[0]
        || vs.filter(function (v) { return v.available; })[0]
        || vs[0] || null;
  }

  function normalize(handle, data) {
    // accepts a live /products/x.js payload or a preview snapshot entry
    if (data && data.__snapshot) {
      return {
        handle: handle,
        name: data.name,
        sku: data.sku,
        apps: data.apps || [],
        price: data.price,
        size: data.size || '100 µL',
        variantId: data.variantId || null,
        available: data.available !== false,
        url: '/products/' + handle
      };
    }
    var v = pickVariant(data);
    return {
      handle: handle,
      name: data.title,
      sku: (v && v.sku) || handle.toUpperCase(),
      apps: appsFromTags(data.tags),
      price: money(v ? v.price : data.price),
      size: (v && (v.option1 || v.public_title)) || (productMode ? '' : '100 µL'),
      variantId: v ? v.id : null,
      available: !!(v && v.available),
      url: routeRoot + 'products/' + handle + (v ? '?variant=' + v.id : '')
    };
  }

  function getProduct(handle) {
    if (cache[handle]) { return cache[handle]; }
    var snap = productMode ? null : snapshot[handle];
    if (snap) {
      snap.__snapshot = true;
      cache[handle] = Promise.resolve(normalize(handle, snap));
      return cache[handle];
    }
    cache[handle] = fetch(routeRoot + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) { throw new Error('not ok'); } return r.json(); })
      .then(function (d) { return normalize(handle, d); })
      .catch(function () {
        return { handle: handle, name: 'View product', sku: handle.toUpperCase(), apps: [], price: '', size: '', variantId: null, available: true, url: routeRoot + 'products/' + handle, failed: true };
      });
    return cache[handle];
  }

  // Bioss application pill colours (mirrors assets/bioss-application-pill-colors.js).
  var APP_COLORS = {
    'WB': '#98c33c', 'IHC-P': '#ebc138', 'IHC-F': '#ee644a', 'IF(IHC-P)': '#2cd4bf',
    'IF(IHC-F)': '#ff62a4', 'IF(ICC)': '#004aad', 'ELISA': '#73caee', 'FCM': '#ff3131', 'IP': '#271264'
  };
  function normApp(label) {
    return String(label || '').replace(/ /g, ' ').replace(/\s+/g, '').replace(/（/g, '(').replace(/）/g, ')').toUpperCase();
  }
  function appColor(label) {
    return APP_COLORS[normApp(label)] || '#7c8496';
  }
  // Canonical application display order used on Bioss product cards.
  var APP_ORDER = ['WB', 'ELISA', 'FCM', 'IP', 'IHC-P', 'IHC-F', 'IF(IHC-P)', 'IF(IHC-F)', 'IF(ICC)'];
  function appRank(label) {
    var i = APP_ORDER.indexOf(normApp(label));
    return i === -1 ? 999 : i;
  }
  function sortApps(apps) {
    return apps.slice().map(function (a, i) { return { a: a, r: appRank(a), i: i }; })
      .sort(function (x, y) { return (x.r - y.r) || (x.i - y.i); })
      .map(function (o) { return o.a; });
  }
  function appsMarkup(apps) {
    if (!apps.length) { return ''; }
    apps = sortApps(apps);
    var max = 4;
    var shown = apps.slice(0, max).map(function (a) {
      return '<li class="bioss-card-application-pill" style="background-color:' + appColor(a) + '">' + esc(a) + '</li>';
    }).join('');
    var extra = apps.length > max ? '<li class="pw-card__apps-more">+' + (apps.length - max) + '</li>' : '';
    return '<ul class="pw-card__apps" aria-label="Applications">' + shown + extra + '</ul>';
  }

  function fillCard(cardEl, p) {
    var priceMarkup = p.price
      ? '<div class="pw-card__price">' + esc(p.price) + (p.size ? ' <span>/ ' + esc(p.size) + '</span>' : '') + '</div>'
      : '<div class="pw-card__price pw-card__price--na">See product</div>';
    var addBtn = p.variantId
      ? '<button type="button" class="pw-card__add" data-pw-add data-variant="' + p.variantId + '" data-name="' + esc(p.target || p.name) + '"' + (!p.available ? ' disabled' : '') + '>' + (p.available ? 'Add to cart' : 'Sold out') + '</button>'
      : '<a class="pw-card__add" href="' + esc(p.url) + '" target="_blank" rel="noopener">View product</a>';
    cardEl.classList.remove('is-loading');
    cardEl.innerHTML =
      '<span class="pw-card__accent" aria-hidden="true"></span>' +
      '<div class="pw-card__head">' +
        '<h4 class="pw-card__target">' + esc(p.target) + '</h4>' +
        '<span class="pw-card__sku">' + esc(p.sku) + '</span>' +
      '</div>' +
      '<a class="pw-card__name" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(p.name) + '</a>' +
      appsMarkup(p.apps) +
      (p.alts ? '<a class="pw-card__more" href="' + searchUrl(p.search || p.target) + '" target="_blank" rel="noopener">+ ' + p.alts + ' more ' + (p.alts > 1 ? 'antibodies' : 'antibody') + '</a>' : '') +
      '<div class="pw-card__foot">' +
        priceMarkup +
        '<div class="pw-card__buttons">' +
          addBtn +
          '<a class="pw-card__view" href="' + esc(p.url) + '" target="_blank" rel="noopener" aria-label="View ' + esc(p.target) + ' product page">View</a>' +
        '</div>' +
      '</div>';
  }

  function renderCards(list) {
    if (cardObserver) cardObserver.disconnect();
    cardsEl.innerHTML =
      '<div class="pw-carousel" data-pw-carousel>' +
        '<button type="button" class="pw-carousel__nav pw-carousel__nav--prev" data-pw-prev aria-label="Previous products">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<div class="pw-carousel__viewport" data-pw-viewport tabindex="0" aria-label="Related pathway products, scrollable">' +
          '<div class="pw-carousel__track" data-pw-track></div>' +
        '</div>' +
        '<button type="button" class="pw-carousel__nav pw-carousel__nav--next" data-pw-next aria-label="More products">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<div class="pw-carousel__progress" aria-hidden="true"><span data-pw-progress-bar></span></div>' +
      '</div>';

    var track = cardsEl.querySelector('[data-pw-track]');
    var observer = productMode && 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { observer.unobserve(entry.target); entry.target.loadPathwayCard(); } });
    }, { rootMargin: '200px' }) : null;
    cardObserver = observer;
    list.forEach(function (item) {
      var card = document.createElement('article');
      card.className = 'pw-card is-loading';
      card.setAttribute('data-handle', item.handle);
      card.innerHTML =
        '<span class="pw-card__accent" aria-hidden="true"></span>' +
        '<div class="pw-card__head"><h4 class="pw-card__target">' + esc(item.target) + '</h4>' +
        '<span class="pw-card__sku">' + item.handle.toUpperCase() + '</span></div>' +
        '<div class="pw-card__skeleton"></div>';
      track.appendChild(card);
      card.loadPathwayCard = function () { getProduct(item.handle).then(function (p) {
        p.target = item.target;
        p.alts = productMode ? 0 : item.alts || 0;
        p.search = item.search || item.target;
        fillCard(card, p);
      }); };
      if (observer) observer.observe(card); else card.loadPathwayCard();
    });

    initCarousel(cardsEl.querySelector('[data-pw-carousel]'));
  }

  function initCarousel(wrap) {
    if (!wrap) { return; }
    var viewport = wrap.querySelector('[data-pw-viewport]');
    var prev = wrap.querySelector('[data-pw-prev]');
    var next = wrap.querySelector('[data-pw-next]');
    var progress = wrap.querySelector('.pw-carousel__progress');
    var bar = wrap.querySelector('[data-pw-progress-bar]');

    function metrics() {
      var sw = viewport.scrollWidth, cw = viewport.clientWidth;
      return { sw: sw, cw: cw, max: Math.max(0, sw - cw), x: viewport.scrollLeft };
    }
    function step() { return Math.max(viewport.clientWidth * 0.85, 220); }

    function update() {
      var m = metrics();
      var atStart = m.x <= 2;
      var atEnd = m.x >= m.max - 2;
      wrap.classList.toggle('is-start', atStart);
      wrap.classList.toggle('is-end', atEnd || m.max <= 0);
      if (prev) { prev.disabled = atStart; }
      if (next) { next.disabled = atEnd || m.max <= 0; }
      if (bar && progress) {
        var ratio = m.sw > 0 ? m.cw / m.sw : 1;         // thumb width fraction
        var w = Math.max(0.14, Math.min(1, ratio));
        bar.style.width = (w * 100) + '%';
        var pos = m.max > 0 ? m.x / m.max : 0;           // scroll position 0..1
        var travel = Math.max(0, progress.clientWidth - bar.offsetWidth);
        bar.style.left = (pos * travel) + 'px';
      }
    }

    var scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (prev) { prev.addEventListener('click', function () { viewport.scrollBy({ left: -step(), behavior: scrollBehavior }); }); }
    if (next) { next.addEventListener('click', function () { viewport.scrollBy({ left: step(), behavior: scrollBehavior }); }); }
    viewport.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { window.requestAnimationFrame(update); });

    // draggable / click-to-jump scrollbar
    if (progress) {
      var dragging = false;
      function jumpTo(clientX) {
        var rect = progress.getBoundingClientRect();
        var tw = bar.offsetWidth;
        var travel = Math.max(1, rect.width - tw);
        var p = (clientX - rect.left - tw / 2) / travel;
        p = Math.max(0, Math.min(1, p));
        viewport.scrollLeft = p * metrics().max;
        update();
      }
      progress.addEventListener('pointerdown', function (e) {
        dragging = true;
        progress.classList.add('is-dragging');
        viewport.style.scrollBehavior = 'auto';
        if (progress.setPointerCapture) { try { progress.setPointerCapture(e.pointerId); } catch (err) {} }
        jumpTo(e.clientX);
        e.preventDefault();
      });
      progress.addEventListener('pointermove', function (e) { if (dragging) { jumpTo(e.clientX); } });
      function endDrag() {
        if (!dragging) { return; }
        dragging = false;
        progress.classList.remove('is-dragging');
        viewport.style.scrollBehavior = '';
      }
      progress.addEventListener('pointerup', endDrag);
      progress.addEventListener('pointercancel', endDrag);
    }

    // recalc after cards fill in (async data)
    window.setTimeout(update, 80);
    window.setTimeout(update, 400);
    update();
  }

  // ----- Add to cart -----
  function updateCartCount() {
    fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var count = c.item_count;
        var sels = ['[data-cart-count]', '.cart-count', '#CartCount', '.site-header__cart-count', '.cart-link__bubble', '.header__cart-count'];
        sels.forEach(function (s) {
          document.querySelectorAll(s).forEach(function (el) { el.textContent = count; });
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { count: count } }));
        if (productMode && window.BiossCartDrawer) window.BiossCartDrawer.refresh();
      }).catch(function () {});
  }

  function flashAdded(btn) {
    var old = btn.textContent;
    btn.classList.add('is-added');
    btn.textContent = 'Added ✓';
    btn.disabled = true;
    window.setTimeout(function () {
      btn.classList.remove('is-added');
      btn.textContent = old;
      btn.disabled = false;
    }, 2200);
  }

  cardsEl.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-pw-add]') : null;
    if (!btn) { return; }
    e.preventDefault();
    var id = btn.getAttribute('data-variant');
    if (!id || btn.disabled) { return; }

    if (isPreview) { flashAdded(btn); return; } // demo mode for the offline preview

    btn.disabled = true;
    var prev = btn.textContent;
    if (productStatus) productStatus.textContent = '';
    btn.textContent = 'Adding…';
    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) { throw new Error('add failed'); }
      return r.json();
    }).then(function () {
      btn.textContent = prev;
      flashAdded(btn);
      updateCartCount();
      if (productStatus) productStatus.textContent = 'Added to your cart. You can continue shopping.';
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = prev;
      if (productStatus) productStatus.textContent = 'We could not confirm this addition. Check your cart before trying again.';
      else window.location.href = '/cart';
    });
  });

  // ----- show cards vs. quick-links based on active pathway -----
  function sync() {
    var s = activeSlug();
    var list = MANIFEST[s];
    if (productMode && list) list = list.filter(function (item) { return item.handle !== currentHandle; });
    if (list) {
      cardsEl.hidden = false;
      if (targetGroup) { targetGroup.hidden = true; }
      if (renderedSlug !== s) { renderCards(list); renderedSlug = s; }
    } else {
      cardsEl.hidden = true;
      cardsEl.innerHTML = '';
      renderedSlug = null;
      if (targetGroup) { targetGroup.hidden = false; }
    }
    if (collectionGroup) { collectionGroup.hidden = false; }
  }

  if (productMode) {
    var metadata = JSON.parse(root.querySelector('[data-product-pathway-data]').textContent);
    var matches = metadata.filter(function (pathway) { return MANIFEST[pathway.key] && MANIFEST[pathway.key].some(function (item) { return item.handle === currentHandle; }); });
    if (!matches.length) return;
    pathwaySelect.innerHTML = matches.map(function (p) { return '<option value="' + esc(p.key) + '">' + esc(p.title) + '</option>'; }).join('');
    root.querySelector('[data-pathway-chooser]').hidden = matches.length < 2;
    function showPathway() {
      var p = matches.filter(function (p) { return p.key === pathwaySelect.value; })[0];
      root.querySelector('[data-bioss-pathway-products-title]').textContent = 'Shop ' + p.title + ' targets';
      root.querySelector('[data-bioss-pathway-summary]').textContent = p.summary;
      root.querySelector('[data-product-pathway-collections]').innerHTML = p.collections.map(function (c) { return '<a href="' + esc(routeRoot + c.href.replace(/^\//, '')) + '">' + esc(c.label) + '</a>'; }).join('');
      root.querySelector('[data-product-pathway-poster]').hash = slug(p.title);
      productStatus.textContent = '';
      sync();
    }
    pathwaySelect.addEventListener('change', showPathway);
    root.hidden = false;
    showPathway();
    return;
  }
  if (titleEl && 'MutationObserver' in window) {
    new MutationObserver(sync).observe(titleEl, { childList: true, characterData: true, subtree: true });
  }
  window.addEventListener('hashchange', function () { window.setTimeout(sync, 0); });

  sync();
  if (window.requestAnimationFrame) { window.requestAnimationFrame(sync); }
  window.setTimeout(sync, 60);
})();
